import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { estateSchemaObject } from '../../Data'
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import factoryService from '../../Factory/services';
import groupService from '../../Group/services';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'ESTATE';

export function EstateAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Estate")
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState()
    const [isChanged, setIsChanged] = useState(0);
    const [estate, setEstate] = useState({
        groupID: '0',
        operationEntityCode: '',
        operationEntityName: '',
        operationEntityLocation: '',
        isActive: true
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });

    const schema = Joi.object(estateSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [estate]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITESTATE');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Estate")
            setEstate(data)
            setButtonName("Update")
        } else {
            setTitle("Add Estate");
            var token = tokenService.getUserDetailsFromToken();
            setEstate({
                ...estate,
                groupID: token.groupID
            });
        }

        trackPromise(
            getAllGroups()
        )
    }

    async function getAllGroups() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups)
    }

    function handleChange(e) {
        const target = e.target

        if (target.name === "operationEntityCode") {
            if (target.value.length === 3) return false
        }

        const value = target.name === 'isActive' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, estateSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setEstate({
            ...estate,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, estate)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

        if (!edit) {
            const response = await services.saveEstate(estate)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editData(estate)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/estates' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setEstate({
            ...estate,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityCode: '',
            operationEntityName: '',
            operationEntityLocation: '',
            isActive: true
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/estates"
                            isChanged={isChanged}
                        />
                        <hr />

                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">

                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <TextField fullWidth select label="Group *"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={estate.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group--</option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <span id="errbranchCode" className="text text-danger">{errors["groupID"]}</span>}
                                    </div>
                                    <div className="col-md-4">

                                        <TextField fullWidth label="Estate Code *"
                                            name="operationEntityCode"
                                            id="operationEntityCode"
                                            value={estate.operationEntityCode}
                                            type="number"
                                            maxLength="2"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["operationEntityCode"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityCode"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Estate Name *"
                                            name="operationEntityName"
                                            id="operationEntityName"
                                            value={estate.operationEntityName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["operationEntityName"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityName"]}</span>}
                                    </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-4">

                                            <TextField fullWidth label="Estate Location"
                                            name="operationEntityLocation"
                                            id="operationEntityLocation"
                                            value={estate.operationEntityLocation}
                                                type="text"
                                                onChange={(e) => handleChange(e)} />
                                        {errors["operationEntityLocation"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityLocation"]}</span>}
                                        </div>
                                   </div>
                                    <label>Active</label>
                                    <div className="form-group row">
                                        <div className="col-md-4">
                                            <input
                                                className="mr-2"
                                                id="isActive"
                                                switch="none"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange(e)}
                                                checked={estate.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                   </div>
                                    </div>
                              
                           
                            <div className="card-footer">
                                <input
                                    disabled={validate(schema, estate)}
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}
                                />
                                <input
                                    type="button"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}